import { useAtom } from '@reatom/npm-react'
import { AnimatePresence, motion } from 'motion/react'
import { useId } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { Typography } from '@blade/ui-kit'
import { Grid4OutlineIcon, Rows3Icon } from '@root/shared/ui-kit'

import { notificationCenterAdditionalWidgetsViewAtom } from '../../atoms'

import { WIDGET_SIZE } from './notification-center-settings-widget'

const HANDLE_SIZE = 28

export const NotificationCenterSettingsLayout: React.FC = () => {
  const { t } = useTranslation()
  const indicatorLayoutId = useId()

  const [view, setView] = useAtom(notificationCenterAdditionalWidgetsViewAtom)

  return (
    <Root>
      <Heading>{t('notification-center.additional_widgets_view')}</Heading>
      <Switch role="group">
        <Item data-active={view === 'row'} onClick={() => setView('row')}>
          <AnimatePresence>
            {view === 'row' ? (
              <Indicator
                layoutId={indicatorLayoutId}
                initial={false}
                transition={{ type: 'spring', stiffness: 520, damping: 36 }}
              />
            ) : undefined}
          </AnimatePresence>
          <Rows3Icon size={16} />
        </Item>
        <Item data-active={view === 'square'} onClick={() => setView('square')}>
          <AnimatePresence>
            {view === 'square' ? (
              <Indicator
                layoutId={indicatorLayoutId}
                initial={false}
                transition={{ type: 'spring', stiffness: 520, damping: 36 }}
              />
            ) : undefined}
          </AnimatePresence>
          <Grid4OutlineIcon size={12} />
        </Item>
      </Switch>
    </Root>
  )
}

const Root = styled.div`
  background: var(--backgroundA-2);
  border: 1px solid var(--backgroundA-2);

  display: grid;
  grid-template-columns: 1fr auto;
  border-radius: 10px;
  padding: 0 15px;
  padding-inline-end: 10px;
  align-items: center;
  height: ${WIDGET_SIZE}px;
`

const Heading = styled(Typography).attrs({
  variant: 'body4-semi-bold',
  component: 'h2',
})`
  color: var(--text-11);
`

const Switch = styled.div`
  --handle-size: ${HANDLE_SIZE}px;

  background: var(--backgroundA-2);

  display: flex;
  border-radius: 22px;
  position: relative;
  padding: 2px;
`

const Item = styled.div`
  width: var(--handle-size);
  height: var(--handle-size);
  color: var(--text-9);

  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition:
    color 0.18s ease-out,
    transform 0.18s ease-out;
  position: relative;

  &[data-active='true'] {
    color: var(--text-12);
    transform: scale(1.06);
  }
`

const Indicator = styled(motion.div)`
  width: var(--handle-size);
  height: var(--handle-size);
  background: var(--backgroundA-5);

  position: absolute;
  inset: 0;
  border-radius: 50%;
`
